export type Barcodes = Set<string>;

export interface ScannedWorklistItem {
  // the identifier encoded by the scanned barcode
  scannedIdentifier: string;
  apiId: string | null;
  notFound: boolean;
}

// NOTE: Using a Map here is important because it preserves insertion order when iterating
export type ScannedWorklistItemsByIdentifier = Map<string, Array<ScannedWorklistItem>>;

export enum COLUMN_TYPE {
  SCANNED_IDENTIFIER = 'Scanned Identifier',
  CHIP = 'Chip',
  CONTENTS = 'Contents',
  TRASH = '',
}

export const SCANNED_CONTAINERS_TABLE_COLUMNS: Array<{type: COLUMN_TYPE; width: number}> = [
  {
    type: COLUMN_TYPE.SCANNED_IDENTIFIER,
    width: 3,
  },
  {
    type: COLUMN_TYPE.CHIP,
    width: 4,
  },
  {
    type: COLUMN_TYPE.CONTENTS,
    width: 4,
  },
  {
    type: COLUMN_TYPE.TRASH,
    width: 1,
  },
];

export const SCANNED_WORKLIST_ITEMS_TABLE_COLUMNS: Array<{type: COLUMN_TYPE; width: number}> = [
  {
    type: COLUMN_TYPE.SCANNED_IDENTIFIER,
    width: 5,
  },
  {
    type: COLUMN_TYPE.CHIP,
    width: 6,
  },
  {
    type: COLUMN_TYPE.TRASH,
    width: 1,
  },
];
